import { SeatCharacteristic as SeatCharacteristicEnum } from '@eti/schema-types';
export function getSeatCharacteristicLabels(characteristic, isUnavailable, t) {
  if (isUnavailable) {
    return [t('Product.SeatMap.Characteristic.Unavailable.Label'), t('Product.SeatMap.Characteristic.Unavailable.Description')];
  }
  switch (characteristic) {
    case SeatCharacteristicEnum.LegSpace:
      return [t('Product.SeatMap.Characteristic.ExtraLegroom.Label'), t('Product.SeatMap.Characteristic.ExtraLegroom.Description')];
    case SeatCharacteristicEnum.FrontOfCabin:
      return [t('Product.SeatMap.Characteristic.FrontRow.Label'), t('Product.SeatMap.Characteristic.FrontRow.Description')];
    case SeatCharacteristicEnum.EconomyComfort:
      return [t('Product.SeatMap.Characteristic.EconomyComfort.Label'), t('Product.SeatMap.Characteristic.EconomyComfort.Description')];
    case SeatCharacteristicEnum.Normal:
    default:
      return [t('Product.SeatMap.Characteristic.Standard.Label'), t('Product.SeatMap.Characteristic.Standard.Description')];
  }
}
//# sourceMappingURL=seatCharacteristicText.js.map